<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" :class="['size', sizeClass]">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
</template>

<script>
export default {
  name: 'IcCopy',

  props: {
    lg: {
      type: Boolean,
      default: false
    },
    sm: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    sizeClass() {
      return {
        'lg': this.lg,
        'sm': this.sm
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.size {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: middle;
  &.lg {
    width: 1.25em;
    height: 1.25em;
  }
  &.sm {
    width: 0.85em;
    height: 0.85em;
  }
}
</style>
